import { LOGOUT as PUBLIC_ACTION_LOGOUT, LOGIN_SUCCESS as PUBLIC_ACTION_LOGIN_SUCCESS } from '@comeon/actions-public';
import selectSplashtechState from './splashtech-state-selector';
import reducerRegistry from '@comeon/reducer-registry';
import SplashtechApiClient from './splashtech-api-client';
import * as SplashtechTypes from './types';
import { getCookies, setPermanentCookie } from '../../../store/cookies';

const ACTION_PREFIX = '@komigen/splashtech';
const SUCCESS = 'SUCCESS';
const FAILURE = 'FAILURE';

// Actions
const START_FETCH_SPLASHTECH_ELIGIBLE = `${ACTION_PREFIX}/START_FETCH_SPLASHTECH_ELIGIBLE`;
const FETCH_SPLASHTECH_ELIGIBLE = `${ACTION_PREFIX}/FETCH_SPLASHTECH_ELIGIBLE`;
const FETCH_SPLASHTECH_ELIGIBLE_ERROR = `${ACTION_PREFIX}/FETCH_SPLASHTECH_ELIGIBLE_ERROR`;
const SPLASHTECH_CAMPAIGN_LOADING = `${ACTION_PREFIX}/SPLASHTECH_CAMPAIGN_LOADING`;
const SPLASHTECH_CAMPAIGN_SUCCESS = `${ACTION_PREFIX}/SPLASHTECH_CAMPAIGN_SUCCESS`;
const SPLASHTECH_CAMPAIGN_FAILURE = `${ACTION_PREFIX}/SPLASHTECH_CAMPAIGN_FAILURE`;
const OPEN = `${ACTION_PREFIX}/OPEN`;
const CLOSE = `${ACTION_PREFIX}/CLOSE`;
const POPUP_CLOSED = `${ACTION_PREFIX}/POPUP_CLOSE`;
const SPLASHTECH_POPUP_CLOSED_ERROR = `${ACTION_PREFIX}/SPLASHTECH_POPUP_CLOSED_ERROR`;

export const REDUCER_NAME = 'splashtech';
export const selectShowUserSplashtech = (state: SplashtechTypes.RootState) =>
	selectSplashtechState(state).showUserSplashtech;

export const selectSplashtechCard = (state: SplashtechTypes.RootState) => {
	const {
		src,
		descriptionKey,
		srcIneligible,
		titleKey,
		titleKeyIneligible,
		eligible,
		type,
		auth,
		productCategoryCodes
	} = selectSplashtechState(state);
	return {
		src: eligible || !auth ? src : srcIneligible,
		titleKey: eligible || !auth ? titleKey : titleKeyIneligible,
		descriptionKey,
		type,
		productCategoryCodes
	};
};
export const selectSplashtechIframeUrl = (state: SplashtechTypes.RootState) => selectSplashtechState(state).iFrameUrl;
export const selectSplashtechImgSrc = (state: SplashtechTypes.RootState) => selectSplashtechState(state).src;
export const selectSplashtechClaimed = (state: SplashtechTypes.RootState) => selectSplashtechState(state).claimed;
export const selectSplashtechEligible = (state: SplashtechTypes.RootState) => selectSplashtechState(state).eligible;
export const selectSplashtechPopupClosed = (state: SplashtechTypes.RootState) =>
	selectSplashtechState(state).popupClosed;
export const selectSplashtechLoading = (state: SplashtechTypes.RootState) => selectSplashtechState(state).isLoading;

export const fetchSplashtechCampaign =
	(splashtechOnLogin: boolean): SplashtechTypes.ThunkAction =>
	async dispatch => {
		dispatch({
			type: SPLASHTECH_CAMPAIGN_LOADING
		});

		const { status, result } = await SplashtechApiClient.fetchCampaignForUser();
		if (status === SUCCESS) {
			const { url, claimed, campaign, popupClosed, productCategoryCodes } = result;
			const activeSplashCookie = getCookies('active_splash_campaign');
			let showUserSplashtech = false;
			if ((!activeSplashCookie || activeSplashCookie !== campaign) && splashtechOnLogin) {
				const expiry = new Date();
				const twoWeeks = 14 * 60 * 60 * 24 * 1000;
				expiry.setTime(expiry.getTime() + twoWeeks);
				setPermanentCookie('active_splash_campaign', campaign, expiry);
				showUserSplashtech = true;
			}
			return dispatch({
				type: SPLASHTECH_CAMPAIGN_SUCCESS,
				payload: { url, claimed, showUserSplashtech, popupClosed, productCategoryCodes }
			});
		}
		return dispatch({
			type: SPLASHTECH_CAMPAIGN_FAILURE
		});
	};

export const fetcSpashtechEligible = (): SplashtechTypes.ThunkAction => async dispatch => {
	dispatch({
		type: START_FETCH_SPLASHTECH_ELIGIBLE
	});
	const { status, result } = await SplashtechApiClient.fetchUserEligible();
	if (status === SUCCESS) {
		return dispatch({
			type: FETCH_SPLASHTECH_ELIGIBLE,
			payload: result
		});
	}
	return dispatch({
		type: FETCH_SPLASHTECH_ELIGIBLE_ERROR
	});
};

export const showSplashtech = (): SplashtechTypes.ThunkAction => dispatch => {
	return dispatch({ type: OPEN });
};

export const hideSplashtech = (): SplashtechTypes.ThunkAction => async (dispatch, getState) => {
	const popupClosed = selectSplashtechPopupClosed(getState());
	dispatch({ type: CLOSE });
	if (popupClosed) return;
	try {
		const { status } = await SplashtechApiClient.setPopupClosed();
		if (status === FAILURE) {
			return dispatch({ type: SPLASHTECH_POPUP_CLOSED_ERROR });
		}
		return dispatch({ type: POPUP_CLOSED });
	} catch (error) {
		return dispatch({ type: SPLASHTECH_POPUP_CLOSED_ERROR });
	}
};

// export const hideSplashtech = (): SplashtechTypes.ThunkAction => dispatch => {
// 	return dispatch({ type: CLOSE });
// };

const initialState: SplashtechTypes.SplashtechReducerState = {
	apiUrl: '',
	iFrameUrl: '',
	campaignName: '',
	isLoading: false,
	hasFailure: false,
	showUserSplashtech: false,
	eligible: false,
	fetchingEligible: false,
	titleKey: '',
	titleKeyIneligible: '',
	claimed: false,
	src: '',
	srcIneligible: '',
	descriptionKey: '',
	type: '',
	auth: false,
	popupClosed: false,
	productCategoryCodes: []
};

export type SplashtechDuckPayload = SplashtechTypes.SplashtechCampaign;
const reducer = (
	state = initialState,
	{
		type = '',
		payload
	}: {
		type: string;
		payload: SplashtechDuckPayload;
	}
) => {
	switch (type) {
		case SPLASHTECH_CAMPAIGN_LOADING:
			return {
				...state,
				isLoading: true
			};
		case SPLASHTECH_CAMPAIGN_SUCCESS:
			return {
				...state,
				isLoading: false,
				showUserSplashtech: payload.showUserSplashtech,
				iFrameUrl: payload.url,
				claimed: payload.claimed,
				popupClosed: payload.popupClosed,
				productCategoryCodes: payload.productCategoryCodes
			};
		case SPLASHTECH_CAMPAIGN_FAILURE:
			return {
				...state,
				showUserSplashtech: false,
				hasFailure: true,
				isLoading: false
			};
		case START_FETCH_SPLASHTECH_ELIGIBLE:
			return {
				...state,
				fetchingEligible: true
			};
		case FETCH_SPLASHTECH_ELIGIBLE:
			return {
				...state,
				fetchingEligible: false,
				eligible: payload
			};
		case PUBLIC_ACTION_LOGIN_SUCCESS:
			return {
				...state,
				auth: true
			};
		case PUBLIC_ACTION_LOGOUT:
			return {
				...state,
				iFrameUrl: '',
				campaignName: '',
				eligible: false,
				isLoading: false,
				hasFailure: false,
				claimed: false,
				showUserSplashtech: false,
				auth: false
			};
		case OPEN:
			return {
				...state,
				showUserSplashtech: true
			};
		case CLOSE:
			return {
				...state,
				showUserSplashtech: false
			};
		case POPUP_CLOSED:
			return {
				...state,
				popupClosed: true
			};
		default:
			return state;
	}
};

reducerRegistry.register(REDUCER_NAME, reducer);

export type State = ReturnType<typeof reducer>;

export default reducer;
